var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpayLogo1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 188.42,
    height: 59.546,
    viewBox: "0 0 188.42 59.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spay_logo",
    transform: "translate(0.003 0.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.003 -0.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M35,32.979l6.945-4.343A8.293,8.293,0,0,0,49.6,33.6c2.92,0,4.717-1.4,4.717-3.5,0-6.7-17.671-3.575-17.671-16.6,0-7.656,6.178-11.232,12.243-11.232A15.687,15.687,0,0,1,60.7,7.689l-5.616,5.316a8.7,8.7,0,0,0-6.252-3.313c-2.04,0-3.744,1.011-3.744,3.182,0,6.646,17.615,3.126,17.615,17.3,0,7.151-6.065,11.363-13.216,11.363A16.286,16.286,0,0,1,35,32.979Z",
    transform: "translate(30.524 2.044)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M40.467,31.072v2.265H39.25V27.253h2.228a2.265,2.265,0,0,1,1.629.524,2.037,2.037,0,0,1-.019,2.789,2.377,2.377,0,0,1-1.61.505ZM42.339,29.2a1.011,1.011,0,0,0-.243-.711,1.235,1.235,0,0,0-.824-.243h-.8v1.872h.88c.711-.019,1.067-.318,1.067-.936Z",
    transform: "translate(34.23 23.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M45.035,28.177a1.46,1.46,0,0,1,.618.768v-.9H46.87v4.68H45.653V31.79a1.46,1.46,0,0,1-.618.768,1.872,1.872,0,0,1-1.03.281,2.134,2.134,0,0,1-1.086-.281,1.984,1.984,0,0,1-.749-.861A2.789,2.789,0,0,1,41.89,30.4a2.883,2.883,0,0,1,.281-1.31,1.984,1.984,0,0,1,.749-.861,2.134,2.134,0,0,1,1.086-.281A1.872,1.872,0,0,1,45.035,28.177Zm-1.554,1.142a1.385,1.385,0,0,0-.356,1.03,1.367,1.367,0,0,0,.356,1.011,1.161,1.161,0,0,0,.9.356,1.179,1.179,0,0,0,.917-.374,1.348,1.348,0,0,0,.356-.992,1.441,1.441,0,0,0-.356-1.03,1.236,1.236,0,0,0-.917-.374,1.179,1.179,0,0,0-.9.374Z",
    transform: "translate(36.532 24.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M46.2,28l1.31,3.239L48.706,28h1.348l-2.92,7.057H45.786l1.067-2.415L44.85,28Z",
    transform: "translate(39.113 24.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M55.4,28.412a2.228,2.228,0,0,1,.487,1.535v2.771h-1.2V30.079a1.179,1.179,0,0,0-.281-.842.992.992,0,0,0-.768-.3,1.123,1.123,0,0,0-.824.318,1.367,1.367,0,0,0-.3.936v2.527h-1.2V30.079a1.179,1.179,0,0,0-.281-.842.992.992,0,0,0-.768-.3,1.123,1.123,0,0,0-.824.318,1.367,1.367,0,0,0-.3.936v2.527H47.93v-4.68h1.217v.9a1.591,1.591,0,0,1,.6-.711,1.872,1.872,0,0,1,.955-.262,1.685,1.685,0,0,1,1.647,1.067,1.872,1.872,0,0,1,.674-.768,1.685,1.685,0,0,1,.992-.3,1.872,1.872,0,0,1,1.385.449Z",
    transform: "translate(41.799 24.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M57.31,30.6h-3.5a1.273,1.273,0,0,0,.356.936,1.067,1.067,0,0,0,.786.3,1.1,1.1,0,0,0,.711-.206.9.9,0,0,0,.356-.562h1.273a1.872,1.872,0,0,1-.393.9,2.209,2.209,0,0,1-.8.618,2.508,2.508,0,0,1-1.086.225,2.415,2.415,0,0,1-1.235-.3,2.022,2.022,0,0,1-.842-.842,2.976,2.976,0,0,1,0-2.6,2.19,2.19,0,0,1,.842-.861,2.621,2.621,0,0,1,1.236-.281,2.565,2.565,0,0,1,1.236.281,2.134,2.134,0,0,1,.824.8,2.509,2.509,0,0,1,.3,1.179A1.872,1.872,0,0,1,57.31,30.6Zm-1.479-1.423a1.142,1.142,0,0,0-.824-.3,1.179,1.179,0,0,0-.824.3,1.235,1.235,0,0,0-.374.88h2.321A1.067,1.067,0,0,0,55.831,29.175Z",
    transform: "translate(45.897 24.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M59.776,28.413a2.19,2.19,0,0,1,.487,1.535v2.771h-1.2V30.079a1.2,1.2,0,0,0-.3-.88,1.048,1.048,0,0,0-.8-.318,1.067,1.067,0,0,0-.824.337,1.385,1.385,0,0,0-.3.973v2.527H55.62v-4.68h1.217v.955a1.348,1.348,0,0,1,.618-.749,1.872,1.872,0,0,1,1.011-.281A1.685,1.685,0,0,1,59.776,28.413Z",
    transform: "translate(48.505 24.451)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M61.343,32.181v1.048h-.562a1.741,1.741,0,0,1-1.235-.393,1.647,1.647,0,0,1-.431-1.292V29.485H58.46v-.936h.655V27.37h1.217v1.179h1.011v1.03H60.276v2.078a.655.655,0,0,0,.15.487.637.637,0,0,0,.468.131Z",
    transform: "translate(50.981 23.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M65.548,32.574a1.76,1.76,0,0,1-.693.636,2.471,2.471,0,0,1-1.1.225,3.2,3.2,0,0,1-1.161-.206,2,2,0,0,1-.824-.636,1.741,1.741,0,0,1-.337-.973h1.292a.973.973,0,0,0,.3.618.9.9,0,0,0,.674.243.73.73,0,0,0,.58-.206.753.753,0,0,0,.037-.992A1.329,1.329,0,0,0,63.9,31a6.232,6.232,0,0,0-.693-.262l-.936-.374a1.7,1.7,0,0,1-.618-.543,1.741,1.741,0,0,1,.318-2.171,2.34,2.34,0,0,1,1.5-.449A2.415,2.415,0,0,1,65,27.669,1.76,1.76,0,0,1,65.66,28.9H64.387a.9.9,0,0,0-.281-.524.842.842,0,0,0-.618-.225.861.861,0,0,0-.543.187.636.636,0,0,0-.206.505.6.6,0,0,0,.168.449,1.5,1.5,0,0,0,.393.281l.674.262a6.178,6.178,0,0,1,.955.393,1.554,1.554,0,0,1,.618.543,1.46,1.46,0,0,1,.262.936,1.685,1.685,0,0,1-.262.861Z",
    transform: "translate(53.553 23.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M64.357,27.087a.88.88,0,0,1,1.086,0,.655.655,0,0,1,.206.487.636.636,0,0,1-.206.468.88.88,0,0,1-1.086,0,.656.656,0,0,1,0-.955ZM65.5,28.959v4.68H64.282v-4.68Z",
    transform: "translate(55.942 23.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M72.91,28.423a2.134,2.134,0,0,1,.505,1.535v2.771h-1.2V30.09a1.179,1.179,0,0,0-.281-.842.992.992,0,0,0-.768-.3,1.123,1.123,0,0,0-.824.318,1.366,1.366,0,0,0-.3.936v2.527h-1.2V30.09a1.179,1.179,0,0,0-.281-.842.992.992,0,0,0-.768-.3,1.1,1.1,0,0,0-.824.318,1.273,1.273,0,0,0-.3.936v2.527H65.46v-4.68h1.217v.9a1.591,1.591,0,0,1,.6-.711,1.691,1.691,0,0,1,2.508.786,1.872,1.872,0,0,1,.674-.768,1.685,1.685,0,0,1,.992-.3,1.872,1.872,0,0,1,1.46.468Z",
    transform: "translate(57.085 24.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M74.23,28.161a1.984,1.984,0,0,1,.749.861,2.883,2.883,0,0,1,.281,1.31,2.79,2.79,0,0,1-.281,1.292,1.984,1.984,0,0,1-.749.861,2.134,2.134,0,0,1-1.086.281,1.872,1.872,0,0,1-1.03-.281,1.666,1.666,0,0,1-.618-.768v3.276H70.28V28.03H71.5v.992a1.666,1.666,0,0,1,.618-.768,1.872,1.872,0,0,1,1.03-.281A2.134,2.134,0,0,1,74.23,28.161ZM71.852,29.3a1.441,1.441,0,0,0-.356,1.03,1.348,1.348,0,0,0,.356.992,1.179,1.179,0,0,0,.917.374,1.161,1.161,0,0,0,.9-.356,1.366,1.366,0,0,0,.356-1.011,1.385,1.385,0,0,0-.356-1.03,1.179,1.179,0,0,0-.9-.374A1.236,1.236,0,0,0,71.852,29.3Z",
    transform: "translate(61.288 24.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M74.617,27.09v6.383H73.4V27.09Z",
    transform: "translate(64.008 23.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M74.766,27.088a.861.861,0,0,1,.543-.187.786.786,0,0,1,.543.187.619.619,0,0,1,0,.955.786.786,0,0,1-.543.187.861.861,0,0,1-.543-.187.636.636,0,0,1-.206-.468.655.655,0,0,1,.206-.487Zm1.161,1.872v4.68H74.71v-4.68Z",
    transform: "translate(65.02 23.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M77.664,28.116a.842.842,0,0,0-.225.655h.973V29.8H77.44v3.744H76.279V29.8h-.6v-.917h.6v-.112a1.741,1.741,0,0,1,.487-1.31,2.04,2.04,0,0,1,1.46-.468h.243V28.06a.955.955,0,0,0-.8.056Z",
    transform: "translate(65.996 23.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M77.656,27.087A.861.861,0,0,1,78.2,26.9a.824.824,0,0,1,.543.187.656.656,0,0,1,0,.955.824.824,0,0,1-.543.187.861.861,0,0,1-.543-.187.636.636,0,0,1-.206-.468.655.655,0,0,1,.206-.487Zm1.161,1.872v4.68H77.6v-4.68Z",
    transform: "translate(67.54 23.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M83.32,30.6h-3.5a1.273,1.273,0,0,0,.356.936,1.067,1.067,0,0,0,.786.3,1.1,1.1,0,0,0,.711-.206.9.9,0,0,0,.356-.562H83.3a1.872,1.872,0,0,1-.393.9,2.209,2.209,0,0,1-.8.618,2.508,2.508,0,0,1-1.086.225,2.415,2.415,0,0,1-1.236-.3,2.022,2.022,0,0,1-.842-.842,2.976,2.976,0,0,1,0-2.6,2.19,2.19,0,0,1,.842-.861,2.864,2.864,0,0,1,2.471,0,2.134,2.134,0,0,1,.824.8,2.509,2.509,0,0,1,.3,1.179,1.871,1.871,0,0,1-.056.412Zm-1.479-1.423a1.142,1.142,0,0,0-.824-.3,1.179,1.179,0,0,0-.824.3,1.236,1.236,0,0,0-.374.88h2.321A1.067,1.067,0,0,0,81.841,29.174Z",
    transform: "translate(68.577 24.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M84.646,28.925a1.666,1.666,0,0,1,.618.768v-2.6h1.2v6.383h-1.2v-.936a1.666,1.666,0,0,1-.618.768,1.872,1.872,0,0,1-1.03.281,2.209,2.209,0,0,1-1.1-.281,2.115,2.115,0,0,1-.749-.861,2.789,2.789,0,0,1-.262-1.292,2.883,2.883,0,0,1,.262-1.31,2.115,2.115,0,0,1,.749-.861,2.209,2.209,0,0,1,1.1-.281A1.872,1.872,0,0,1,84.646,28.925Zm-1.572,1.142a1.46,1.46,0,0,0-.337,1.03,1.441,1.441,0,0,0,.337,1.011,1.2,1.2,0,0,0,.917.356,1.142,1.142,0,0,0,.9-.374,1.348,1.348,0,0,0,.374-.992,1.441,1.441,0,0,0-.374-1.03,1.2,1.2,0,0,0-.9-.374,1.217,1.217,0,0,0-.917.374Z",
    transform: "translate(71.07 23.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M52.54,2.009H67.516A12.261,12.261,0,0,1,80.432,14.925,12.243,12.243,0,0,1,67.591,27.8h-6.7V41.769H52.54ZM67.516,19.4a4.231,4.231,0,0,0,4.605-4.474,4.231,4.231,0,0,0-4.511-4.511h-6.72v9.06Z",
    transform: "translate(45.819 1.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M67.852,22.545a13.553,13.553,0,0,1,13.1-13.853,11.588,11.588,0,0,1,7.057,2.153V9.272h8.33V35.929H88.575V34.057a11.831,11.831,0,0,1-7.488,2.4A13.534,13.534,0,0,1,67.852,22.545Zm20.442,0a6.009,6.009,0,1,0-1.72,4.341,6.065,6.065,0,0,0,1.72-4.341Z",
    transform: "translate(59.166 7.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M114.3,9,99.1,46.926H90.429l4.9-12.542L85,9h9.117l5.616,15.144L105.367,9Z",
    transform: "translate(74.123 7.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M34.1,14.467H10.062a1.367,1.367,0,0,1-.88-2.321l9.36-9.36a9.7,9.7,0,0,1,13.684,0l4.68,4.923A3.969,3.969,0,0,1,34.1,14.467Z",
    transform: "translate(7.671 0.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M11.118,23.561H35.155a1.367,1.367,0,0,1,.973,2.321l-9.36,9.36a9.678,9.678,0,0,1-13.665,0L8.254,30.375a3.95,3.95,0,0,1,2.864-6.814Z",
    transform: "translate(6.128 20.616)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M9.111,16.24H49.976c1.872,0,2.7,2.752,1.423,4.362L46.419,26.91A1.872,1.872,0,0,1,45,27.659H14.09a1.872,1.872,0,0,1-1.423-.749L7.688,20.6C6.415,18.992,7.314,16.24,9.111,16.24Z",
    transform: "translate(6.189 14.235)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M.62,15.987l5.2-6.327A1.872,1.872,0,0,1,7.3,8.93H39.67a1.872,1.872,0,0,1,1.479.73l5.2,6.327c1.329,1.61.449,4.306-1.423,4.306H2.118C.227,20.293-.709,17.6.62,15.987Z",
    transform: "translate(0.003 7.86)",
    fill: "#00aeef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpayLogo1);
export default __webpack_public_path__ + "static/media/spay_logo-1.704fddb55675151243877bc09c744cbd.svg";
export { ForwardRef as ReactComponent };